import "./blogs.css"
import Catalogue from './category/category.js';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card'
import { Route, Link, useRouteMatch, Switch } from 'react-router-dom';
import Contents from "./contents/contents";

const blogIcons = {
    "qgis": {
        "location": "/blogs-image/QGIS_logo.svg",
        "title": "QGIS3",
        "description": `QGIS3 Plugins are a great way to extend the functionality, which allows you to 
                        interact with the map, access feature attributes and custom the UI as whatever you perfer, etc.`
    },

    // 'leaflet': {
    //     "location": "/blogs-image/Leaflet_logo.svg",
    //     "title": "Leaflet / React Leaflet",
    //     "description": `Leaflet is the leading open-source JavaScript library for mobile-friendly interactive maps where
    //                     you can build up a web map app by utilising React Leaflet.`
    // }
}

function BlogMainPage({ match }) {
    // console.log(match);
    // console.log(`${match.url}/qgis`);
    // let { path, url } = useRouteMatch();
    // console.log(`${url}/qgis`);
    return (
        <Container>
            {/* <Row className="justify-content-md-center"> */}
            <Row >
                {Object.keys(blogIcons).map((key, index) => (
                    <Col key={index} md="6" >
                        <br />

                        <Link to={`${match.url}/${key}`} className="card-anchor">
                            <Card border="Secondary" className="h-100">
                                <Card.Img variant="top" src={process.env.PUBLIC_URL + blogIcons[key]["location"]}
                                    style={{ width: '50%', height: '5rem', marginLeft: 'auto', marginRight: 'auto', paddingTop:'20px' }} />
                                <Card.Body>
                                    <Card.Title>{blogIcons[key]["title"]}</Card.Title>
                                    <Card.Text >
                                        {blogIcons[key]["description"]}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Link>

                    </Col>
                ))}
            </Row>
        </Container >
    )
}

function Blog() {
    let { path, url } = useRouteMatch();

    return (
        // https://reactrouter.com/web/example/nesting
        <div>
            <Switch>
                <Route exact path={path} component={BlogMainPage} />
                <Route exact path={`${path}/:topic`}>
                    <Catalogue />
                </Route>
                {/* <Redirect exact from="/blogs" to="/blogs"  /> */}
                <Route path={`${path}/:topic/:title`}>
                    <Contents/>
                </Route>
            </Switch>
        </div>

    )
}

export default Blog;